import { ModelSagres } from "@/types/model-sagres";

export interface TipoAvaliacaoGeralJson {
  id: number;
  descricao: string;
}

export class TipoAvaliacaoGeral extends ModelSagres {
  id: number;
  descricao: string;

  /**
   * @param obj
   */
  constructor(obj?: TipoAvaliacaoGeralJson) {
    super();
    if (obj) {
      this.id = obj.id;
      this.descricao = obj.descricao;
    }
  }
}